import Styles from "features/configuration/common/styles";
import styled, { css } from "styled-components";

export const StyledCard = styled(Styles.Card)`
  height: auto;
  display: flex;
  justify-content: space-between;
  padding: 16px 20px;
  ${(p) =>
    p.theme.isNewLook &&
    css`
      align-items: center;
      gap: 16px;
      min-height: 52px;
      padding: 8px 12px 8px 20px;
    `}
`;
